"use client";

import type { Participant } from "./base-session-template";
import { ActivityDisplayPreview } from "./previews";

// ──────────────────────────────────────────────────────────────────────────────
// TYPES
// ──────────────────────────────────────────────────────────────────────────────

export type RunType = "easy" | "tempo" | "interval" | "long" | "race";

export type RunningTemplateData = {
  runType: RunType;
  distance: number; // km
  time: { hours?: number; minutes: number; seconds: number };
  pace?: string; // calculated
};

export type RunningParticipant = Participant;

// ──────────────────────────────────────────────────────────────────────────────
// DISPLAY COMPONENT (for feed)
// ──────────────────────────────────────────────────────────────────────────────

type RunningDisplayProps = {
  data: RunningTemplateData | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function RunningDisplay({ data, participants }: RunningDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="running"
      data={data}
      participants={participants}
    />
  );
}
